import { buildMedicationFormSchema } from '../../../../../common';
import { MEDICATION_TEXT_MIN_LENGTH } from './constants';

export const MEDICATION_FORM_SCHEMA = buildMedicationFormSchema({
  medicationNameMinLength: MEDICATION_TEXT_MIN_LENGTH,
  physicianNameMinLength: MEDICATION_TEXT_MIN_LENGTH,
});
